<script lang="ts">
  import SettingsHeader from "@modern/components/retailer/settings/Pricing/SettingsHeader.svelte";
  import CustomPricesTable from "@modern/components/retailer/settings/Pricing/CustomPricesTable.svelte";
  import Autocomplete from "@shared/svelte/Components/Autocomplete.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import type { Distributor } from "@shared/types/Distributor";
  import SettingsPageWrapper from "@modern/components/retailer/settings/PageWrapper.svelte";

  let distributors: Distributor[] = [];
  let distributorSearch: string;

  const distributorSearchResults = e => {
    distributors = [e.detail];
  };

  const fullList = () => {
    return HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
        with_custom_price_counts: true,
      },
    }).then(res => {
      distributors = res;
    });
  };
  fullList();

</script>

<SettingsPageWrapper>
  <div class="padding--small">
    <SettingsHeader />

    <Autocomplete
      placeholder="Filter Distributor Accounts..."
      objectType="distributor"
      searchUrlInput={`/api/retailer/distributors/search`}
      addFromAutocompleteOnly={false}
      apiParams={{
        search: distributorSearch,
        current_retailer_only: true,
        with_custom_price_counts: true,
      }}
      on:change={distributorSearchResults}
      on:clear={fullList}
    />

    <CustomPricesTable bind:distributors />
  </div>
</SettingsPageWrapper>
